import React from "react";
import styled from "styled-components";
import { Row, Col, Empty, Button, Spin } from "antd";
import {
  StyledTitle,
  TitleContainer,
} from "components/job/index/jobInformationRow";
import TasksList from "./todo/tasksList";
import DatelinesList from "./dateline/datelinesList";
import LoadFromTemplateModal from "components/job/index/modal/loadFromTemplateModal";
import NewNoTemplateModal from "./modal/newNoTemplateModal";

const DatelineAndTodoRow = (props) => {
  // Props
  const { data, status } = props;

  // Component state
  const [openTodoTemplateModal, setOpenTodoTemplateModal] = React.useState(
    false
  );
  const [openNewTodoModal, setOpenNewTodoModal] = React.useState(false);

  const [
    openDatelineTemplateModal,
    setOpenDatelineTemplateModal,
  ] = React.useState(false);
  const [openNewDatelineModal, setOpenNewDatelineModal] = React.useState(false);

  return (
    <StyledContainer>
      <Row gutter={8}>
        <Col xs={12} style={{ paddingLeft: "2px" }}>
          <StyledBox>
            <TitleContainer>
              <StyledTitle>Dateline</StyledTitle>
            </TitleContainer>
            {status === "loading" || status === "idle" ? (
              <SpinContainer>
                <Spin />
              </SpinContainer>
            ) : (
              <>
                {data?.dateline?.length > 0 ? (
                  <DatelinesList
                    datelines={data.dateline}
                    status={status}
                    jobId={data.id}
                    jobStatus={data.status}
                  />
                ) : (
                  <EmptyContainer>
                    <Empty
                      image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                      imageStyle={{
                        height: 60,
                      }}
                      description={<span>No dateline yet</span>}
                      style={{ marginBottom: "20px" }}
                    >
                      <Button
                        type="primary"
                        onClick={() => setOpenDatelineTemplateModal(true)}
                      >
                        Load from template
                      </Button>
                      <Button
                        onClick={() => setOpenNewDatelineModal(true)}
                        style={{ marginLeft: "7px" }}
                      >
                        Setup new dateline
                      </Button>
                    </Empty>
                  </EmptyContainer>
                )}
              </>
            )}
          </StyledBox>
        </Col>
        <Col xs={12} style={{ paddingRight: "2px" }}>
          <StyledBox>
            <Row>
              <TitleContainer>
                <StyledTitle>To-Do</StyledTitle>
              </TitleContainer>
            </Row>
            {status === "loading" || status === "idle" ? (
              <SpinContainer>
                <Spin />
              </SpinContainer>
            ) : (
              <>
                {data?.todo ? (
                  <TasksList
                    tasks={data.todo.tasks}
                    status={status}
                    jobId={data.id}
                    todoId={data.todo.id}
                  />
                ) : (
                  <EmptyContainer>
                    <Empty
                      image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                      imageStyle={{
                        height: 60,
                      }}
                      description={<span>No todo yet</span>}
                      style={{ marginBottom: "20px" }}
                    >
                      <Button
                        type="primary"
                        onClick={() => setOpenTodoTemplateModal(true)}
                      >
                        Load from template
                      </Button>
                      <Button
                        onClick={() => setOpenNewTodoModal(true)}
                        style={{ marginLeft: "7px" }}
                      >
                        Setup new todo
                      </Button>
                    </Empty>
                  </EmptyContainer>
                )}
              </>
            )}
          </StyledBox>
        </Col>
      </Row>
      <LoadFromTemplateModal
        todo
        visible={openTodoTemplateModal}
        onCancel={() => setOpenTodoTemplateModal(false)}
        title="Load todo from template"
      />
      <NewNoTemplateModal
        todo
        visible={openNewTodoModal}
        onCancel={() => setOpenNewTodoModal(false)}
        title="Set New Todo"
      />
      <LoadFromTemplateModal
        dateline
        visible={openDatelineTemplateModal}
        onCancel={() => setOpenDatelineTemplateModal(false)}
        title="Load dateline from template"
      />
      <NewNoTemplateModal
        dateline
        visible={openNewDatelineModal}
        onCancel={() => setOpenNewDatelineModal(false)}
        title="Set New Dateline"
      />
    </StyledContainer>
  );
};

const StyledBox = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.grey[400]};
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const EmptyContainer = styled.div`
  display: flex;
  height: 90%;
  align-items: center;
  justify-content: center;
  margin-bottom: ${(props) => props.theme.spacing[4]};
`;

const SpinContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  height: 90%;
`;

const StyledContainer = styled.div`
  margin-bottom: ${(props) => props.theme.spacing[2]};
`;

export default DatelineAndTodoRow;
